import React from 'react';
import Header from '@components/layouts/Header';
import { Container } from '@mui/material';

interface Props {
  children: React.ReactNode;
}
const BaseLayout = ({ children }: Props) => {
  return (
    <Container maxWidth="xl">
      <Header />
      {children}
    </Container>
  );
};
export default BaseLayout;
